import { useUnit } from 'effector-react'

import { $gameConnectConfig } from '@/entities/game'
import { $portalProfile } from '@/entities/profile/portal'

import { VersionBadge } from '../version-badge/view'

export type ClientVersionInfoProps = {
    className?: string
}

export function ClientVersionInfo({ className }: ClientVersionInfoProps) {
    const connectConfig = useUnit($gameConnectConfig)
    const clientVersion = connectConfig?.client_version ?? ''
    const profile = useUnit($portalProfile)

    if (!clientVersion || profile?.tester !== true) {
        return null
    }

    return <VersionBadge label="Client" value={clientVersion} className={className} />
}
